import Storage from './Storage'
import { AUTH_KEY } from '@/enums/cacheEnum'

export const setUrlParams = function (
  url: string,
  key: string,
  value: string,
  param = {}
) {
  const query = getUrlParam(url)
  const origin = url.split('?')[0]
  if (Object.keys(query).length === 0) {
    return `${origin}?${parseParams(param)}`
  }
  query[key] = value
  if (!value) delete query[key]
  const params = {
    ...query,
    ...param,
  }
  return `${origin}?${parseParams(params)}`
}

// json转url参数
export const parseParams = function (data: any) {
  try {
    const tempArr = []
    for (const i in data) {
      const key = encodeURIComponent(i)
      const value = encodeURIComponent(data[i])
      tempArr.push(key + '=' + value)
    }
    const urlParamsStr = tempArr.join('&')
    return urlParamsStr
  } catch (err) {
    return ''
  }
}

export const getUrlParam = function (sUrl: string, sKey?: string) {
  const result: any = {} //用来存储参数键值对
  sUrl.replace(
    /\??(\w+)=([\w+-@%*?#!~`();"']+)&?/g,
    function (str, key, value): any {
      if (result[key] !== undefined) {
        //键值已定义
        const t = result[key]
        result[key] = [].concat(t, value) //把新元素拼接成一个数组
      } else {
        //键值未定义
        result[key] = value //直接为对象创建这个新属性
      }
    }
  )

  if (sKey === undefined) {
    //函数第二个参数未传入时，返回整个对象
    return result
  } else {
    //传入了第二个参数，直接返回键值
    return result[sKey] || ''
  }
}

export const equipmentType = function () {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  if (isAndroid) {
    return 'android'
  } else if (isiOS) {
    return 'ios'
  } else {
    return 'web'
  }
}

export const splitTimeDate = (
  d: any,
  config = { format: 'yyyy-mm-dd', split: '.' }
) => {
  if (!d) return ''
  d = d.replace(/-/g, '/')
  const date = new Date(d)
  if (date.toString() === 'Invalid Date') return ''
  const year = date.getFullYear()
  const month = markZero(date.getMonth() + 1)
  const day = markZero(date.getDate())
  const hours = markZero(date.getHours())
  const min = markZero(date.getMinutes())
  if (config.format === 'yyyy-mm-dd mm:hh') {
    const list_before = [year, month, day]
    const list_after = [hours, min]
    return `${list_before.join(config.split)} ${list_after.join(':')}`
  }
  // yyyy-mm-dd
  const list = [year, month, day]
  return list.join(config.split)
}

// 补零
export const markZero = (n: any, len = 2) => {
  const str = (n / Math.pow(10, len)).toFixed(len) + ''
  len = len == null ? 2 : len
  return str.substr(str.indexOf('.') + 1)
}

export const getDateStr = (AddDayCount = 0) => {
  const date = new Date()
  date.setDate(date.getDate() + AddDayCount) // 获取AddDayCount天后的日期
  const year = date.getFullYear()
  const mon = date.getMonth() // 获取当前月份的日期
  const day = date.getDate()
  const result = {
    year,
    mon,
    day,
  }
  return result
}

/**
 * 判断某个原生DOM元素是否不在屏幕可见区内
 * @param {*} el 原生DOM元素 num 一定距离内可见
 */
export const isElementNotInViewport = (el: any, num: any) => {
  if (!el) return false
  const rect = el.getBoundingClientRect()
  return (
    rect.top + num >=
      (window.innerHeight || document.documentElement.clientHeight) ||
    rect.bottom <= 0
  )
}

/**
 * 图形字体换算方法
 * 当前视口
 */
export const nowSize = (val: any, initWidth = 375) => {
  const nowClientWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  return val * (nowClientWidth / initWidth)
}
export const getWeekEnText = (val: any) => {
  const list = ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun']
  return list[Number(val)] || ''
}
export const getMonthEnText = (val: any) => {
  const list = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ]
  return list[Number(val)] || ''
}
export const LISTYEAR = (minYear = 2011) => {
  const nowYear = new Date().getFullYear()
  let year = minYear
  const list = []
  while (year <= nowYear) {
    list.push({
      label: `${year}`,
      value: year,
    })
    year++
  }
  return list
}

export const getListDate = () => {
  const LISTMONTH = [
      { label: '01', value: 1, en: 'Jan' },
      { label: '02', value: 2, en: 'Feb' },
      { label: '03', value: 3, en: 'Mar' },
      { label: '04', value: 4, en: 'Apr' },
      { label: '05', value: 5, en: 'May' },
      { label: '06', value: 6, en: 'Jun' },
      { label: '07', value: 7, en: 'Jul' },
      { label: '08', value: 8, en: 'Aug' },
      { label: '09', value: 9, en: 'Sept' },
      { label: '10', value: 10, en: 'Oct' },
      { label: '11', value: 11, en: 'Nov' },
      { label: '12', value: 12, en: 'Dec' },
    ],
    LISTQUARTER = [
      { label: '01季度', value: 1 },
      { label: '02季度', value: 2 },
      { label: '03季度', value: 3 },
      { label: '04季度', value: 4 },
    ]
  const result = {
    LISTMONTH,
    LISTQUARTER,
  }
  return result
}

// 随机串16位
export const getRandomStr = () => {
  const str = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let val = ''
  for (let i = 0; i < 16; i++) {
    val += str.substr(Math.round(Math.random() * 10), 1)
  }
  return val
}

// 获取授权链接
export const getWxOAuthPath = (query: any = '') => {
  Storage.remove(AUTH_KEY)
  const wxoauth_origin = process.env.VUE_APP_API_URL
  const authkey = getRandomStr()
  Storage.set(AUTH_KEY, authkey)
  return `${wxoauth_origin}/wxoauth/wxoauth?key=${authkey}&${query}`
}

// 获取纯文本内容
export const getInnerTextContent = function (cotent: string) {
  const val = cotent || ''
  const div = document.createElement('div')
  div.innerHTML = val
  return div.innerText || ''
}

// 获取视频时长
export const getVideoFormatHSM = function (t: number) {
  let videoTime = t
  const h = ~~(t / 3600)
  videoTime = videoTime - 3600 * h
  const m = ~~(videoTime / 60)
  const s = videoTime % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(
    s
  ).padStart(2, '0')}`
}
